/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';

export function mobileNav() {
  var hamburger = document.querySelector('.hamburger');
  var body = document.querySelector('body');
  var subListItems = document.querySelectorAll('.mainNav__listItem--hasSubList');

  hamburger.addEventListener('click', function () {
    hamburger.classList.toggle('is-active');
    if (body.classList.contains('navOpen')) {
      body.classList.remove('navOpen');
    } else {
      body.classList.add('navOpen');
    }
  });

  subListItems.forEach(element => {
    element.classList.add('closed');
  });

  if (window.innerWidth < 960) {

    $('.mainNav__subListContainer').hide();

    $('.mainNav__listItem--hasSubList').on('click tap', function() {
      $(this).toggleClass('closed');
      $(this).toggleClass('open');
      $(this).find('.mainNav__subListContainer').slideToggle();
    });
  }
}

